import {Component} from '@angular/core';

@Component({
    selector: 'app-sidebar-footer',
    standalone: true,
    template: ``,
        imports: []
})
export class AppSidebarFooterComponent {

    constructor() {
    }
}